
const m = window.require("@ember/component/checkbox");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
